<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card class="card--shadow">
            <list :members="members" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import List from "@/components/member/List";
import { mapState } from "vuex";

export default {
  components: {
    List,
  },
  computed: {
    ...mapState("Member", ["members"]),
  },
  created() {
    this.$store.dispatch("Member/get");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
